import { Cup } from "./Cup";
import { ISwiss } from "../../typings/typings";
import { IRound } from "ng-league";

export class Swiss extends Cup implements ISwiss {
    public rounds: IRound[] = [];
    public maxLosses: number;

    constructor(jsonData) {
        super(jsonData);
        this.rounds = jsonData.rounds;
        this.maxLosses = jsonData.maxLosses;
    }

    /**
     * Override templates
     * @param template
     * @param $filter
     * @param $scope
     * @returns {string}
     */
    public getUrlByTemplate(template: string, $filter, $scope) {
        switch (template) {
            case "Information":
                return $filter("sprintf")($scope.templateUrls.templateInformationUrl, "swiss");
            case "Match":
                return $filter("sprintf")($scope.templateUrls.templateMatchUrl, "swiss");
            default:
                return super.getUrlByTemplate(template, $filter, $scope);
        }
    }

    public getRound(index: number) {
        if (this.rounds.length <= index) {
            return null;
        }

        return this.rounds[index];
    }

    /**
     * @param round
     * @returns {number}
     */
    public getRoundIn(round: IRound) {
        let date: Date;

        if (round === null) {
            date = new Date(0);
        } else {
            date = new Date(round.begin);
        }

        return this.getSecondsUntilDate(date);
    }
}
